
import React, { useState,useEffect } from "react";
import "./Residential_projects.css";
import api from "../../Api.js"
import { useNavigate } from "react-router-dom";
import { getProperties } from "../../Services/Operations/ProductAPI.js";

const properties = [
  {
    status: "Available",
    name: "Luxury Villa kalyani best place",
    address: "Salt Lake, Kolkata",
    price: "45,00,000",
    image: "https://images.unsplash.com/photo-1568605114967-8130f3a36994",
  },
  {
    status: "Available",
    name: "Modern Apartment",
    address: "New Town, Kolkata",
    price: "32,00,000",
    image: "https://images.unsplash.com/photo-1570129477492-45c003edd2be",
  },
  {
    status: "Available",
    name: "Luxury Villa",
    address: "Salt Lake, Kolkata",
    price: "45,00,000",
    image: "https://images.unsplash.com/photo-1568605114967-8130f3a36994",
  },
  {
    status: "Available",
    name: "Modern Apartment",
    address: "New Town, Kolkata",
    price: "32,00,000",
    image: "https://images.unsplash.com/photo-1570129477492-45c003edd2be",
  },
  {
    status: "Available",
    name: "Luxury Villa",
    address: "Salt Lake, Kolkata",
    price: "45,00,000",
    image: "https://images.unsplash.com/photo-1568605114967-8130f3a36994",
  },
  {
    status: "Available",
    name: "Modern Apartment",
    address: "New Town, Kolkata",
    price: "32,00,000",
    image: "https://images.unsplash.com/photo-1570129477492-45c003edd2be",
  },
  {
    status: "Available",
    name: "Luxury Villa",
    address: "Salt Lake, Kolkata",
    price: "45,00,000",
    image: "https://images.unsplash.com/photo-1568605114967-8130f3a36994",
  },
  {
    status: "Available",
    name: "Modern Apartment",
    address: "New Town, Kolkata",
    price: "32,00,000",
    image: "https://images.unsplash.com/photo-1570129477492-45c003edd2be",
  },
  {
    status: "Available",
    name: "Luxury Villa",
    address: "Salt Lake, Kolkata",
    price: "45,00,000",
    image: "https://images.unsplash.com/photo-1568605114967-8130f3a36994",
  },
  {
    status: "Available",
    name: "Modern Apartment",
    address: "New Town, Kolkata",
    price: "32,00,000",
    image: "https://images.unsplash.com/photo-1570129477492-45c003edd2be",
  },
  {
    status: "Available",
    name: "Luxury Villa",
    address: "Salt Lake, Kolkata",
    price: "45,00,000",
    image: "https://images.unsplash.com/photo-1568605114967-8130f3a36994",
  },
  {
    status: "Available",
    name: "Modern Apartment",
    address: "New Town, Kolkata",
    price: "32,00,000",
    image: "https://images.unsplash.com/photo-1570129477492-45c003edd2be",
  },
  {
    status: "Available",
    name: "Luxury Villa",
    address: "Salt Lake, Kolkata",
    price: "45,00,000",
    image: "https://images.unsplash.com/photo-1568605114967-8130f3a36994",
  },
  {
    status: "Available",
    name: "Modern Apartment",
    address: "New Town, Kolkata",
    price: "32,00,000",
    image: "https://images.unsplash.com/photo-1570129477492-45c003edd2be",
  },
  {
    status: "Available",
    name: "Luxury Villa",
    address: "Salt Lake, Kolkata",
    price: "45,00,000",
    image: "https://images.unsplash.com/photo-1568605114967-8130f3a36994",
  },
  {
    status: "Available",
    name: "Modern Apartment",
    address: "New Town, Kolkata",
    price: "32,00,000",
    image: "https://images.unsplash.com/photo-1570129477492-45c003edd2be",
  },
];

const ITEMS_PER_PAGE = 6;

const AvailableProperty = () => {
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
    const [properties, setProperties] = useState([]);
    const naviagte = useNavigate();

  useEffect(() => {
    const fetchProperties = async () => {
      const response = await getProperties()
      if(response.data.status === true){
          setProperties(response.data.data);
      }
    };
fetchProperties();
  
  }, []);


  // 🔍 Search
const PropertyItem = properties.filter(item => item.property_type === "Residential");
  const filtered = PropertyItem.filter(
    (p) =>
      p.property_name.toLowerCase().includes(search.toLowerCase()) ||
      p.location.toLowerCase().includes(search.toLowerCase())
  );

  // 🔃 Sort
  const sorted = [...filtered].sort((a, b) => {
    if (sort === "low") return parseInt(a.price.replace(/,/g, "")) - parseInt(b.price.replace(/,/g, ""));
    if (sort === "high") return parseInt(b.price.replace(/,/g, "")) - parseInt(a.price.replace(/,/g, ""));
    return 0;
  });

  // 📄 Pagination
  const totalPages = Math.ceil(sorted.length / ITEMS_PER_PAGE);
  const start = (currentPage - 1) * ITEMS_PER_PAGE;
  const paginated = sorted.slice(start, start + ITEMS_PER_PAGE);

  return (
    <div className="property-page">
      {/* LEFT SIDEBAR */}
      <aside className="left-bar">
        <h3>Search</h3>
        <input
          type="text"
          placeholder="Search location or name"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <h3>Sort by Price</h3>
        <select onChange={(e) => setSort(e.target.value)}>
          <option value="">Default</option>
          <option value="low">Low to High</option>
          <option value="high">High to Low</option>
        </select>
      </aside>

      {/* CENTER GRID */}
      <main>
        {/* <h2 className="title">Available Properties</h2> */}

        <div className="grid">
          {paginated.map((item, index) => (
            <div
              className="dd-property-card"
              key={index}
              onClick={() => naviagte(`/property-details/${item.id}`)}
            >
              <div className="dd-property-img-wrapper">
                <img
                  src={`https://admin.houseofdhanushdhari.com/public/${item.property_image}`}
                  alt={item.property_image}
                  className="dd-property-img"
                />
                <span className="dd-property-status">Available</span>
              </div>

              <div className="dd-property-content">
                <h4 className="dd-property-title">{item.property_name}</h4>

                <p className="dd-property-location">{item.location}</p>

                <p className="dd-property-price">₹ {item.price}</p>

                <button className="dd-property-btn">Book Now</button>
              </div>
            </div>
          ))}
        </div>

        {/* PAGINATION */}
        <div className="pagination">
          {[...Array(totalPages)].map((_, i) => (
            <button
              key={i}
              className={currentPage === i + 1 ? "active" : ""}
              onClick={() => setCurrentPage(i + 1)}
            >
              {i + 1}
            </button>
          ))}
        </div>
      </main>

      {/* RIGHT FORM */}
      <aside className="right-bar">
        <h3>Contact for Building</h3>
        <form>
          <input type="text" placeholder="Full Name" required />
          <input type="email" placeholder="Email" required />
          <input type="tel" placeholder="Phone" required />
          <select>
            <option>House Construction</option>
            <option>Apartment</option>
            <option>Renovation</option>
            <option>Other</option>
          </select>
          <textarea placeholder="Your requirement"></textarea>
          <button type="submit">Submit</button>
        </form>
      </aside>
    </div>
  );
};

export default AvailableProperty;
